import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Client } from '@df/core/service/client';
import { Status } from '@df/core/status';
import { Basket } from '@df/session/api/basket/basket';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Subscription } from 'rxjs';
import { CheckboxComponent } from '../../../ui/form/checkbox';
import { NFurnitureAssembly } from '../furniture-assembly.namespace';
import { FurnitureAssemblyService } from './../furniture-assembly.service';
@Component({
    selector: 'furniture-assembly-item',
    templateUrl: './furniture-assembly-item.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, CheckboxComponent, PriceComponent, FormsModule, CommonModule, SizeClassDirective]
})
export class FurnitureAssemblyItemComponent implements OnInit, OnDestroy {
    private _checked = false;
    @Input()
    item?: NFurnitureAssembly.IAssemblyItem;
    private subscriptions = new Subscription();
    status = new Status();
    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private furnitureAssemblyService: FurnitureAssemblyService,
        private basket: Basket,
        public client: Client
    ) {}
    ngOnInit(): void {
        this.subscriptions.add(this.basket.subscribe(() => this.onBasketUpdate()));
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.onBasketUpdate();
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    get product(): Product<IProductDataV3> | undefined {
        return this.item?.product;
    }
    get type(): NFurnitureAssembly.EType | undefined {
        return this.item?.type;
    }
    get checked(): boolean {
        return this._checked;
    }
    set checked(value: boolean) {
        if (!this.status.busy) {
            this._checked = value;
            if (this.type && this.isInBasket !== value) {
                this.furnitureAssemblyService.toggle(this.type, this.status);
            }
            this.detectChanges();
        }
    }
    get fieldName(): string {
        return 'furniture_assembly_' + this.type;
    }
    private get isInBasket(): boolean {
        return !!this.type && this.furnitureAssemblyService.isInBasket(this.type);
    }
    private onBasketUpdate(): void {
        this._checked = this.isInBasket;
        this.detectChanges();
    }
    private detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
